module.exports = __webpack_public_path__ + "img/6830197954876276742.74bd535f.jpeg";